import { useRef } from 'react';

const useScrollWidth = () => {
  const scrollWidth = useRef(null);

  // If we already did the computation, return scroll value
  if ( scrollWidth.current !== null ) return scrollWidth.current;

  // Grab scrollbar width using this method:
  // https://davidwalsh.name/detect-scrollbar-width
  const scrollDiv = document.createElement("div");
  scrollDiv.style.width = "100px"
  scrollDiv.style.height = "100px"
  scrollDiv.style.overflow = "scroll"
  scrollDiv.style.position = "absolute"
  scrollDiv.style.top = "-9999px"
  scrollDiv.className = "scrollbar-measure";
  document.body.appendChild(scrollDiv);

  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

  // Make sure we save the width to avoid computing again
  scrollWidth.current = scrollbarWidth;

  return scrollbarWidth;
}

export default useScrollWidth;
